
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  <ScrollTracking label='content75' mdxType="ScrollTracking" />
  Wer in der Gastrobranche in Bern aktiv ist, dem dürfte Tobias Burkhalter ein Begriff
  sein. Er war der letzte Wirt im Kulturcasino und leitete den Betrieb der Burgergemeinde
  Bern zwischen 2005 und 2017, bis zum Umbau. Mit dem Restaurant Schmiedstube führt
  er das älteste Zunfthaus von Bern, wo Damen Kaffeekränzchen abhalten und dem Lokal
  einen konstanten Fluss an Gästen bescheren. Allerdings will er dem Lokal einen
  frischen Anstrich verpassen, damit wieder jüngere Gäste einkehren.
    </p>
    <p>
  Nebst der Schmiedstube führen er und seine Frau Nilgün mit dem Hotel Goldener
  Schlüssel in der Rathausgasse das älteste Hotel der Bundesstadt. Und das Della
  Casa in der Schauplatzgasse ist das älteste Restaurant auf dem Platz Bern. Die
  rund 100 Personen, die bei Burkhalter Gastro Management angestellt sind, haben
  keinen fixen Arbeitsort im Vertrag, sondern wechseln zwischen den
  verschiedenen Lokalen mit insgesamt 600 Sitzplätzen. «Die Angestellten sind
  froh um die Abwechslung», sagt Burkhalter. Er amtet nicht nur als Wirt: Er
  präsidiert Gastro Stadt Bern und Umgebung. Eine Beteiligung hält er auch an
  Chez Edy, die neu im Ambassador im Kirchenfeld und in Freiburg ein
  Muschelrestaurant eröffnet haben. Falls dieses Konzept zum Fliegen kommt,
  wollen Burkhalter und sein Geschäftspartner Christian Gfeller schweizweit
  Filialen eröffnen. Tobias Burkhalter kommentiert seinen Umsatz nicht.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;